import { render, staticRenderFns } from "./FileUploadComponent.vue?vue&type=template&id=3828d11a&scoped=true"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828d11a",
  null
  
)

export default component.exports